import '~/sass/pages/my-vehicle-video.scss';
import { initDatas } from '@/components/my-vehicle-video-extent';
import '~/js/libs/youtube/lite-yt-embed.css';
import '@/libs/youtube/lite-yt-embed';

const { $ } = window;
$(document).ready(() => {
  initDatas();
});
